"use strict";
/**
 * Utility to mask personal information from candidate data
 * when blind CV mode is enabled. Prevents reverse-engineering
 * of candidate identity through metadata fields.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.maskCandidateForBlindCV = maskCandidateForBlindCV;
exports.maskNestedCandidateForBlindCV = maskNestedCandidateForBlindCV;
const PERSONAL_FIELDS_TO_NULLIFY = [
    'email',
    'linkedinUrl',
    'signalhireId',
    'profileData',
    'cvFileUrl',
    'cvOriginalName',
];
/**
 * Masks personal information from a candidate object for blind CV presentation.
 * Uses the blind alias from the generated CV (if available) as the display name,
 * otherwise falls back to a numbered "Candidate #N" label.
 */
function maskCandidateForBlindCV(candidate, index) {
    const masked = { ...candidate };
    // Use blind alias from generated CV as the display name, fallback to numbered label
    const blindAlias = candidate.generatedCV?.blindAlias;
    masked.name = blindAlias || `Candidate ${index + 1}`;
    // Mask company name (can be used to identify the person)
    masked.currentCompany = null;
    // Nullify all personal identifiable fields
    for (const field of PERSONAL_FIELDS_TO_NULLIFY) {
        masked[field] = field === 'profileData' ? {} : null;
    }
    return masked;
}
/**
 * Masks sourced candidate attributes within a nested object (e.g., rating.sourcedCandidate).
 * Replaces name and currentCompany while preserving non-personal fields.
 */
function maskNestedCandidateForBlindCV(parentObj, candidateKey, aliasMap, index) {
    const result = { ...parentObj };
    const candidate = result[candidateKey];
    if (!candidate)
        return result;
    result[candidateKey] = {
        ...candidate,
        name: aliasMap.get(candidate.id) || `Candidate ${index + 1}`,
        currentCompany: null,
    };
    return result;
}
//# sourceMappingURL=blind-masking.js.map